import {useState} from 'react';
import restAPI from '@app/config/apiConfig';

const InternalPagesAPI = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [response, setResponse] = useState('');

	const getPages = () => {
		setLoading(true);
		setError('');
		setResponse('');

		restAPI.get('pages')
			.then(({data}) => {
				setResponse(data.pages);
			})
			.catch(() => {
				setError('Failed to call API, maybe you are disconnected!');
			})
			.finally(() => {
				setLoading(false);
			});
	}

	return {
		loading,
		error,
		response,
		getPages,
	};
};

export default InternalPagesAPI;
